import dayjs from 'dayjs';
import 'dayjs/locale/az';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hi';
import 'dayjs/locale/it';
import 'dayjs/locale/pt';
import 'dayjs/locale/ro';
import 'dayjs/locale/ru';
import 'dayjs/locale/tr';
import 'dayjs/locale/uk';
import { TFunction } from 'i18next';

import LOCALE_TO_DAYJS from 'constants/localeToDayJs';
import { FALLBACK_VALUE } from 'constants/uiSettings';

const DATE_FORMAT = 'MMMM YYYY';
const DEFAULT_LANG = 'en';

const generateTimePeriodString = ({
  startDate,
  endDate,
  t,
  locale,
  isShowDuration
}: {
  startDate: string | null;
  endDate: string | null;
  t: TFunction;
  locale?: string;
  isShowDuration?: boolean;
}): string => {
  if (!startDate && !endDate) {
    return FALLBACK_VALUE;
  }

  const dayjsLocale = (locale && LOCALE_TO_DAYJS[locale]) || DEFAULT_LANG;
  const start = dayjs(startDate).locale(dayjsLocale);
  const end = (endDate ? dayjs(endDate) : dayjs()).locale(dayjsLocale);

  const startLabel = start.format(DATE_FORMAT);
  const endLabel = endDate ? end.format(DATE_FORMAT) : t('common.present');

  const totalMonths = end.diff(start, 'month');
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  const durationParts: string[] = [];
  if (years > 0) {
    durationParts.push(`${years} ${t('common.year', { count: years })}`);
  }
  if (months > 0) {
    durationParts.push(`${months} ${t('common.month', { count: months })}`);
  }

  const duration = durationParts.join(' ');

  return `${startLabel} — ${endLabel}${duration && isShowDuration ? ` · ${duration}` : ''}`;
};

export default generateTimePeriodString;
